import { checkUserResourcePermissions } from 'sonata-static-storage/lib/helpers/user.helpers';

import type { UserInterface } from 'sonata-static-storage/lib/schemas/user/user.schema';
import type { UserRoleInterface } from 'sonata-static-storage/lib/schemas/user/userRole.schema';

export type CustomAudienceProfileType = 'device_ids' | 'previous_campaign_data' | 'campaign_events' | 'venue_visits';

const CUSTOM_AUDIENCE_PROFILE_PERMISSIONS: Record<CustomAudienceProfileType, string> = {
  campaign_events: 'audienceCustomCampaignEvents',
  device_ids: 'audienceCustomDeviceIds',
  previous_campaign_data: 'audienceCustomPreviousCampaignData',
  venue_visits: 'audienceCustomVenueVisits'
};

export const getAllowedCustomAudienceProfileTypes = (
  user: UserInterface,
  userRoles: UserRoleInterface[]
): CustomAudienceProfileType[] =>
  (Object.keys(CUSTOM_AUDIENCE_PROFILE_PERMISSIONS) as CustomAudienceProfileType[]).filter(type =>
    checkUserResourcePermissions(CUSTOM_AUDIENCE_PROFILE_PERMISSIONS[type], user, userRoles)
  );
